"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var JackpotWinHistoryListCtl = /** @class */ (function (_super) {
    __extends(JackpotWinHistoryListCtl, _super);
    function JackpotWinHistoryListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bonus_jackpot_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_jackpot_id; });
        _this.dk_bonus_jackpot_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_jackpot_title; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_win_amount_jp_currency = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_amount_jp_currency; });
        _this.dk_win_amount_player_currency = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_amount_player_currency; });
        _this.dk_player_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_id; });
        _this.dk_player_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_title; });
        _this.dk_exchange_rate = UIUtils_1.UIUtils.IProp2Str(function (o) { o.exchange_rate; });
        _this.dk_jackpot_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_currency_id; });
        _this.dk_jackpot_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_currency_title; });
        _this.dk_player_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_before; });
        _this.dk_jackpot_balance_money_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_balance_money_before; });
        _this.dk_jackpot_balance_view_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_balance_view_before; });
        _this.dk_player_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_after; });
        _this.dk_jackpot_balance_money_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_balance_money_after; });
        _this.dk_jackpot_balance_view_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_balance_view_after; });
        _this.dk_date_win = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_win; });
        _this.dk_trg_by_usr_admin_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trg_by_usr_admin_id; });
        _this.dk_trg_by_usr_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trg_by_usr_admin_login; });
        _this._errDialog = errDialog;
        return _this;
    }
    JackpotWinHistoryListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    JackpotWinHistoryListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "jackpot win history with id [" + id + "] not found !";
    };
    JackpotWinHistoryListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListJackpotWinnersByJpIdAndDateRangeGet.exec({
            bonus_jackpot_id: data.jackpotId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bonus_jackpot_id: resp.list[i].bonus_jackpot_id,
                    bonus_jackpot_title: resp.list[i].bonus_jackpot_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    win_amount_jp_currency: resp.list[i].win_amount_jp_currency,
                    win_amount_player_currency: resp.list[i].win_amount_player_currency,
                    player_currency_id: resp.list[i].player_currency_id,
                    player_currency_title: resp.list[i].player_currency_title,
                    exchange_rate: resp.list[i].exchange_rate,
                    jackpot_currency_id: resp.list[i].jackpot_currency_id,
                    jackpot_currency_title: resp.list[i].jackpot_currency_title,
                    player_balance_before: resp.list[i].player_balance_before,
                    jackpot_balance_money_before: resp.list[i].jackpot_balance_money_before,
                    jackpot_balance_view_before: resp.list[i].jackpot_balance_view_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    jackpot_balance_money_after: resp.list[i].jackpot_balance_money_after,
                    jackpot_balance_view_after: resp.list[i].jackpot_balance_view_after,
                    date_win: moment(resp.list[i].date_win_uts_ms).utc(false),
                    trg_by_usr_admin_id: resp.list[i].trg_by_usr_admin_id,
                    trg_by_usr_admin_login: resp.list[i].trg_by_usr_admin_login,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotWinHistoryListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddJackpotWinner.exec({
            data: {
                bonus_jackpot_id: data.bonusJackpotId,
                usr_player_id: data.usrPlayerId,
                amount_in_jp_currency: data.amountInJpCurrency
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                bonus_jackpot_id: data.bonusJackpotId,
                bonus_jackpot_title: resp.bonus_jackpot_title,
                usr_player_id: data.usrPlayerId,
                usr_player_login: resp.usr_player_login,
                win_amount_jp_currency: data.amountInJpCurrency,
                win_amount_player_currency: resp.amount_in_player_currency,
                player_currency_id: resp.player_app_currency_id,
                player_currency_title: resp.player_app_currency_title,
                exchange_rate: resp.exchange_rate,
                jackpot_currency_id: resp.jackpot_app_currency_id,
                jackpot_currency_title: resp.jackpot_app_currency_title,
                player_balance_before: resp.player_amount,
                jackpot_balance_money_before: resp.jp_amount_money,
                jackpot_balance_view_before: resp.jp_amount_view,
                player_balance_after: resp.player_amount,
                jackpot_balance_money_after: resp.jp_amount_money,
                jackpot_balance_view_after: resp.jp_amount_view,
                date_win: moment(resp.date_added_uts_ms).utc(false),
                trg_by_usr_admin_id: resp.admin_id,
                trg_by_usr_admin_login: resp.admin_login,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotWinHistoryListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    JackpotWinHistoryListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteJackpotWinner.exec({ data: { brand_bonus_jackpot_winner_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return JackpotWinHistoryListCtl;
}(BaseController_1.BaseController));
exports.JackpotWinHistoryListCtl = JackpotWinHistoryListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ctl/JackpotWinHistoryListCtl.ts
// module id = 969
// module chunks = 0